import { noop } from 'lodash';
import { useEffect } from 'react';

import { GetBasketQuery } from '@generated/gql/graphql';

import { useApplicationEntityUpdate } from './useApplicationEntityUpdate';
import { useCoreServiceTrackingContextUpdate } from './useCoreServiceTrackingContextUpdate';
import { useUpdateAttributionTrackingContext } from './useUpdateAttributionTrackingContext';

const useTrackingContextRefresh = (
  basketData: GetBasketQuery,
  loading?: boolean
) => {
  const { updateCoreServiceContext } = useCoreServiceTrackingContextUpdate();
  const { updateApplicationContext } = useApplicationEntityUpdate();
  const { updateAttributionContext } = useUpdateAttributionTrackingContext();

  const { basket, attributionDetails } = basketData || {};

  useEffect(() => {
    if (!!basket && !loading) {
      updateCoreServiceContext(basket);
      updateApplicationContext(basket);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basket, loading]);

  useEffect(() => {
    if (!!attributionDetails && !loading) {
      updateAttributionContext(attributionDetails);
    }
  }, [attributionDetails, loading, updateAttributionContext]);
};

const useConditionalTrackingContextRefresh = (shouldSkipUpdate = false) =>
  shouldSkipUpdate ? noop : useTrackingContextRefresh;

export { useConditionalTrackingContextRefresh as useTrackingContextRefresh };
